import { Loader } from '@calendly/ui/components/loader'
import { Redirect } from 'react-router-dom'

import { useMeetingTypesPath } from 'hooks/use_meeting_types_path'

import { useNotetakerCoreUiVisible } from './useNotetakerCoreUiVisible'

/** Redirects ineligible users away from Notetaker recap routes; shows a loader while signals resolve. */
export const NotetakerRouteGuard = ({ children }) => {
  const { isVisible, isLoading } = useNotetakerCoreUiVisible({ legacyVisible: true })
  const meetingTypesPath = useMeetingTypesPath()

  if (isLoading) {
    return <Loader data-testid="notetaker-route-guard-loader" />
  }

  if (!isVisible) {
    return <Redirect to={meetingTypesPath} />
  }

  return children
}
